<shrd-uic-message variant="completion" type="error" [headline]="errorI18nKey + 'title' | i18next">
  <div class="content-box">{{ errorI18nKey + 'copy' | i18next }}</div>
  <hr shrdUicHr />
  <a href="#overlay/contact/callus" shrdUicButton class="mt-2 mb-0">
    <shrd-uic-svg-icon icon="contact"></shrd-uic-svg-icon>
    <span title="{{ 'common.label.button.contactUs' | i18next }}">
      {{ 'common.label.button.contactUs' | i18next }}
    </span>
  </a>
</shrd-uic-message>
